import React from 'react';
import AutoSlider from './AutoSlider';
import './AutoSlider.css'
import Banner from './Banner';
import PopularProducts from './PopularProducts';
import Newsletter from './Newsletter';
const Homepage = () => {
  return (
    <>
      <AutoSlider/>
      <Banner/>
      <PopularProducts/>
      <Newsletter/>
    </>
  )
}
export default Homepage